import { Box, Typography, Button } from '@material-ui/core'
import { homeOwner, icons } from '../../../../../../../../assets'
import { useIsXsScreen } from '../../../../../../../../hooks'
import useStyles from './styles'
import { BOSSCAT_PHONE_NUMBER } from 'helpers/constants'

const SpeakWithUs = () => {
    const classes = useStyles()
    const [xsScreen] = useIsXsScreen()
    const pd = xsScreen ? '5px' : '10px'
    const hg = xsScreen ? '160px' : '300px'

    return (
        <Box className={classes.speakContainer}>
            <Box>
                <img
                    alt='numberimage'
                    src={homeOwner}
                    style={{
                        position: 'relative',
                        right: '0px',
                        padding: pd,
                        height: hg
                    }}
                />
            </Box>
            <Box>
                <Box className={classes.containerDetail}>
                    <Typography className={classes.speakTitle} variant={!xsScreen ? 'h4' : 'h6'}><span> Let's talk about </span> your project</Typography>
                    <Typography className={classes.subtitle}>Speak with a live Customer Care Professional M-F, 8:00am - 6:00pm EST</Typography>
                    {!xsScreen
                        ? <a href={`tel:${BOSSCAT_PHONE_NUMBER}`} className={classes.phone}>{BOSSCAT_PHONE_NUMBER}</a>
                        : <Button
                            variant='contained'
                            className={classes.phoneButton}
                            onClick={() => window.open(`tel:${BOSSCAT_PHONE_NUMBER}`, '_blank')}
                            startIcon={<icons.Phone />}
                        >
                            {BOSSCAT_PHONE_NUMBER}
                        </Button>}
                </Box>
            </Box>
        </Box>
    )
}

export default SpeakWithUs
